import type {CompleteTaskPath, CompleteTaskResponse} from '../../http';
import {completeTask} from '../../http';
import {useMutation, useQueryClient} from 'react-query';

export function useCompleteTask() {
	const queryClient = useQueryClient();

	return useMutation<CompleteTaskResponse, unknown, CompleteTaskPath>({
		mutationFn: async (path) => {
			const {data} = await completeTask(path);
			return data;
		},
		onSuccess: (task) => {
			queryClient.setQueryData(['task', task.id], task);
			queryClient.invalidateQueries({queryKey: ['tasks']});
		},
	});
}
